























import { BCol, BContainer, BRow } from "bootstrap-vue";

import ContactListsForm from "@/views/components/contact-lists/contactListsForm.vue";
import useContactsLists from "@/composables/useContactsLists";
import useEngageForm from "@/views/modules/engage/useEngageForm";
import { computed, ref, watch } from "@vue/composition-api";

export default {
    components: {
        BContainer,
        BCol,
        BRow,
        ContactListsForm,
    },
    setup(_, { root }) {
        const bvModal = root.$bvModal;

        const { contactsList } = useContactsLists();
        const { currentStep, goToStep } = useEngageForm(bvModal);

        // @ts-ignore
        const contactListForm = ref<ContactListsForm>(null);

        currentStep.value.action = () => {
            contactListForm.value?.buttonAction("next");
        };

        currentStep.value.previousAction = () => {
            contactListForm.value?.buttonAction("prev");
        };

        const activeTab = computed(() => contactListForm.value?.activeTab);

        const backToOverview = () => {
            goToStep(currentStep.value.nextStepId ?? 0);
        };

        watch(
            [contactsList, activeTab],
            () => {
                if (!contactsList.value) {
                    currentStep.value.isDone = false;
                    return;
                }

                if (activeTab.value === 1 && contactsList.value.contacts?.length) {
                    currentStep.value.isDone = true;
                    return;
                }

                if (activeTab.value === 2 && contactsList.value.name?.length) {
                    currentStep.value.isDone = true;
                    return;
                }

                if (activeTab.value === 3) {
                    currentStep.value.isDone = true;
                    return;
                }

                currentStep.value.isDone = false;
            },
            { deep: true }
        );

        // @STEPBACK
        contactsList.value = {
            name: "",
            description: "",
            contacts: [],
            importedContactData: false,
            updateExistingContacts: true,
        };

        return {
            contactsList,
            contactListForm,
            backToOverview,
        };
    },
};
